import { render } from "./PostCardComponent.vue?vue&type=template&id=2e306c12&scoped=true&ts=true"
import script from "./PostCardComponent.vue?vue&type=script&lang=ts"
export * from "./PostCardComponent.vue?vue&type=script&lang=ts"

import "./PostCardComponent.vue?vue&type=style&index=0&id=2e306c12&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e306c12"]])

export default __exports__